import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-double-right', 'ChevronDoubleRight', [["path",{"d":"m12 18 6-6-6-6M6 18l6-6-6-6","key":"svg-0"}]]);